<template>
  <div class="room-create-container">
    <h2>添加房间</h2>
    <el-card shadow="hover">
      <el-form
        :model="roomForm"
        :rules="rules"
        ref="roomFormRef"
        label-position="top"
        label-width="120px"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="房间号" prop="room_number">
              <el-input v-model="roomForm.room_number" placeholder="请输入房间号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="类型" prop="type">
              <el-select v-model="roomForm.type" placeholder="请选择房间类型">
                <el-option label="标准间" value="standard" />
                <el-option label="单人间" value="single" />
                <el-option label="豪华间" value="deluxe" />
                <el-option label="总统套房" value="presidential" />
                <el-option label="家庭房" value="family" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="状态" prop="status">
              <el-select v-model="roomForm.status" placeholder="请选择房间状态">
                <el-option label="可用" value="available" />
                <el-option label="已占用" value="occupied" />
                <el-option label="清洁中" value="cleaning" />
                <el-option label="维护中" value="maintenance" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="价格" prop="price">
              <el-input v-model="roomForm.price" type="number" placeholder="请输入房间价格" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="容纳人数" prop="capacity">
              <el-input v-model="roomForm.capacity" type="number" placeholder="请输入容纳人数" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="楼层" prop="floor">
              <el-input v-model="roomForm.floor" type="number" placeholder="请输入楼层" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="床型" prop="bed_type">
              <el-select v-model="roomForm.bed_type" placeholder="请选择床型">
                <el-option label="单床" value="single" />
                <el-option label="双床" value="double" />
                <el-option label="大床" value="king" />
                <el-option label="多床" value="multiple" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="面积" prop="area">
              <el-input v-model="roomForm.area" type="number" placeholder="请输入房间面积（平方米）" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="窗户" prop="window">
              <el-radio-group v-model="roomForm.window">
                <el-radio label="有窗">有窗</el-radio>
                <el-radio label="无窗">无窗</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="无烟房" prop="smoke_free">
              <el-switch v-model="roomForm.smoke_free" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="描述" prop="description">
              <el-input v-model="roomForm.description" type="textarea" placeholder="请输入房间描述" rows="4" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <div class="form-actions">
          <el-button @click="handleCancel">取消</el-button>
          <el-button type="primary" @click="handleSubmit">提交</el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import request from '../../api/axios';

export default {
  name: 'RoomCreate',
  setup() {
    const router = useRouter();
    const roomFormRef = ref(null);
    
    const roomForm = ref({
      room_number: '',
      type: 'standard',
      status: 'available',
      price: 0,
      capacity: 2,
      floor: 1,
      bed_type: 'double',
      area: 30,
      window: '有窗',
      smoke_free: true,
      description: ''
    });
    
    const rules = {
      room_number: [
        { required: true, message: '请输入房间号', trigger: 'blur' }
      ],
      type: [
        { required: true, message: '请选择房间类型', trigger: 'change' }
      ],
      status: [
        { required: true, message: '请选择房间状态', trigger: 'change' }
      ],
      price: [
        { required: true, message: '请输入房间价格', trigger: 'blur' },
        { type: 'number', min: 0, message: '价格必须大于等于0', trigger: 'blur' }
      ],
      capacity: [
        { required: true, message: '请输入容纳人数', trigger: 'blur' },
        { type: 'number', min: 1, message: '容纳人数必须大于等于1', trigger: 'blur' }
      ],
      floor: [
        { required: true, message: '请输入楼层', trigger: 'blur' },
        { type: 'number', min: 1, message: '楼层必须大于等于1', trigger: 'blur' }
      ],
      bed_type: [
        { required: true, message: '请选择床型', trigger: 'change' }
      ],
      area: [
        { required: true, message: '请输入房间面积', trigger: 'blur' },
        { type: 'number', min: 1, message: '面积必须大于等于1', trigger: 'blur' }
      ]
    };
    
    // 提交表单
    const handleSubmit = async () => {
      if (!roomFormRef.value) return;
      
      await roomFormRef.value.validate(async (valid) => {
        if (valid) {
          try {
            await request({
              url: '/manage/rooms',
              method: 'post',
              data: roomForm.value
            });
            ElMessage.success('房间创建成功');
            router.push('/rooms/list');
          } catch (error) {
            ElMessage.error('房间创建失败');
            console.error(error);
          }
        } else {
          return false;
        }
      });
    };
    
    // 取消操作
    const handleCancel = () => {
      router.push('/rooms/list');
    };
    
    return {
      roomForm,
      roomFormRef,
      rules,
      handleSubmit,
      handleCancel
    };
  }
};
</script>

<style scoped>
.room-create-container {
  padding: 20px;
}

.room-create-container h2 {
  margin-bottom: 20px;
  color: #333;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

.form-actions .el-button {
  margin-left: 10px;
}
</style>